const PermissionModule = {
  namespaced: true,
  state: {
    permission: []
  },
  mutations: {
    FETCH(state, payload) {
      state.permission = payload
    },
    CLEAR_STATE(state) {
      state.permission = []
    }
  },
  actions: {
    async fetch({ commit }) {
      try {
        let userid = localStorage.getItem('userid')
        // let userid = 123
        const response = await axios.get(
          `/users/getUserPermission/${userid}/w6bdyT2s3vlYfggbLJJi3AXAYme9Y2fi`
        )
        commit('FETCH', response.data)
      } catch (error) {
        throw new Error(error)
      }
    }
  },
  getters: {
    getAll: state => {
      return state.permission
    },
    getByCondition: state => condition => {
      return state.permission.find(item => item == condition)
    }
  }
}

export default PermissionModule



// WEBPACK FOOTER //
// ./src/store/modules/permission.js